/* eslint-disable no-param-reassign */
import React from 'react';
import { isArray, startCase } from 'lodash';
import imageRemoved from '../../../assets/images/image-removed.png';
import ImageLazyLoader from '../../../Components/ImageLazyLoader';
import noImage from '../../../assets/images/no-image.png';

function RenderLhsRhsValues({ historyFieldsData, colType }) {
  console.log('product-damproduct-dam', historyFieldsData);
  const getDynamicValue = (dyn) => {
    let result;

    if (dyn?.optionId) {
      result = dyn.optionId.keyName;
    } else if (dyn?.valueText) {
      result = dyn.valueText;
    } else {
      result = '--';
    }
    return result;
  };

  const getDisplayValue = (key) => {
    if (key === 'folderIds') {
      return 'Folder';
    }
    return startCase(key);
  };

  const renderDynamicColumn = (fields) => {
    return (
      <>
        <b>{startCase(fields.field)}</b>:{' '}
        {fields?.[colType] &&
          Array.isArray(fields?.[colType]) &&
          fields[colType].map((dyn) => {
            return (
              <>
                <b>{startCase(dyn?.lableId?.keyName)}</b>: {getDynamicValue(dyn)}
                <br />
              </>
            );
          })}
      </>
    );
  };

  const renderImage = (fields) => {
    return (
      <>
        <b>{startCase(fields.field)}</b>:{' '}
        {fields[colType] ? <ImageLazyLoader height={200} src={fields[colType] || noImage} imageRemoved={imageRemoved} /> : '--'}
        <br />
      </>
    );
  };

  const renderMainTypeBased = (fields) => {
    if (['croppedImage', 'imageUrl', 'videoThumbnail'].includes(fields?.field)) {
      return <div className="px-2 py-1">{renderImage(fields)}</div>;
    }
    if (fields?.field === 'dynamicDropdown') {
      return <div className="px-2 py-1">{renderDynamicColumn(fields)}</div>;
    }
    if (fields?.field === 'dynamicText') {
      return <div className="px-2 py-1">{renderDynamicColumn(fields)}</div>;
    }
  };

  const renderArray = (fields) => {
    return (
      <>
        <b>{getDisplayValue(fields.field)}</b>:{' '}
        {fields[colType]
          ?.map((val) => {
            if (val?.name) return val?.name;
            if (val?.number) return val?.number;
            if (typeof val === 'string') return val;
            if (fields?.field === 'Factory') return val?.factoryName;
            return '--';
          })
          .join(', ')}
        <br />
      </>
    );
  };

  return (
    <span>
      {isArray(historyFieldsData) && historyFieldsData?.length > 0
        ? historyFieldsData.map((fields, index) => {
            if (['croppedImage', 'imageUrl', 'videoThumbnail', 'dynamicText', 'dynamicDropdown'].includes(fields?.field)) {
              return renderMainTypeBased(fields);
            }
            if (!isArray(fields[colType]) && typeof fields[colType] === 'object') {
              return (
                <div key={index} className="px-2 py-1">
                  <b>{startCase(fields.field)}</b>: {fields[colType]?.name || '--'}
                  <br />
                </div>
              );
            }
            if (isArray(fields[colType])) {
              return (
                <div key={index} className="px-2 py-1">
                  {renderArray(fields)}
                </div>
              );
            }
            if (typeof fields[colType] === 'string') {
              return (
                <div key={index} className="px-2 py-1">
                  <b>{getDisplayValue(fields.field)}</b>: {fields[colType] || '--'}
                </div>
              );
            }
            return (
              <div key={index} className="px-2 py-1">
                <b>{getDisplayValue(fields.field)}</b>: --
              </div>
            );
          })
        : '--'}
    </span>
  );
}

export default RenderLhsRhsValues;
